// Shared keyboard/scroll lifecycle for BaseModal and legacy feature dialogs.
let openCount = 0, previousOverflow = '';
export function manageDialogFocus(panel, close) {
  const returnFocus = document.activeElement;
  if (!openCount++) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  const hadTabindex = panel.hasAttribute('tabindex');
  if (!hadTabindex) panel.tabIndex = -1;
  const elements = () => [...panel.querySelectorAll('button,a[href],input,select,textarea,summary,[tabindex]')]
    .filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[inert]'));
  const topmost = () => [...document.querySelectorAll('[role="dialog"][aria-modal="true"],dialog[open]')]
    .filter(el => el.getClientRects().length && !el.closest('[inert]')).at(-1) === panel;
  const onKeydown = event => {
    if (event.defaultPrevented || !topmost()) return;
    // Top-layer selector menus own Escape/arrows before their containing dialog.
    if ([...document.querySelectorAll('[popover]:popover-open')].some(el => el.contains(document.activeElement))) return;
    if (CSS.supports('selector(select:open)') && document.activeElement?.matches('select:open')) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close?.(); }
    if (event.key !== 'Tab') return;
    const options = elements(), first = options[0], last = options.at(-1);
    if (!options.length || (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement)))) {
      event.preventDefault(); (last || panel).focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault(); (first || panel).focus();
    }
  };
  document.addEventListener('keydown', onKeydown);
  let active = true;
  queueMicrotask(() => {
    if (active && topmost()) (panel.querySelector('[autofocus]') || elements()[0] || panel).focus({ preventScroll:true });
  });
  return () => {
    if (!active) return;
    active = false;
    document.removeEventListener('keydown', onKeydown);
    if (!hadTabindex) panel.removeAttribute('tabindex');
    openCount = Math.max(0, openCount - 1);
    if (!openCount) document.body.style.overflow = previousOverflow;
    if (returnFocus?.isConnected && !returnFocus.closest('[inert]')) returnFocus.focus({ preventScroll:true });
  };
}
const dialogs = new WeakMap();
export const dialogFocus = {
  mounted(element, binding) {
    const state = { close: binding.value };
    state.destroy = manageDialogFocus(element, () => state.close?.());
    dialogs.set(element, state);
  },
  updated(element, binding) { const state = dialogs.get(element); if (state) state.close = binding.value; },
  beforeUnmount(element) { dialogs.get(element)?.destroy(); dialogs.delete(element); }
};
